/* eslint no-shadow: ["error", { "allow": ["state"] }] */

import Vue from 'vue'

import { FETCH_RECIPE, FETCH_RECIPES } from '../../actions.type'
import {
  CREATE_RECIPE,
  REMOVE_RECIPE,
  SET_RECIPE_ALL_REQUEST,
  SET_RECIPE_ALL_VALUE,
  UPDATE_RECIPE
} from '../../mutations.type'

const state = {
  all: {
    request: {
      isLoading: undefined,
      isSuccess: undefined,
      isError: undefined,
      isFatalError: undefined,
      delay: undefined,
      lastRequestTime: undefined
    },
    value: []
  }
}

const getters = {
  recipeAllValue: (state) => state.all.value,
  recipeAllRequest: (state) => state.all.request,
  recipeAllById: (state) => {
    const result = {}
    state.all.value.forEach((recipe) => {
      result[recipe.id] = recipe
    })
    return result
  },
  recipeByBeverageId: (state) => (beverageId) =>
    state.all.value.find((recipe) => recipe.beverage?.id === beverageId)
}

const actions = {
  async [FETCH_RECIPES]({ commit, state }, params) {
    if (
      (state.all.request.isSuccess && !params?.isReload) ||
      state.all.request.isLoading ||
      state.all.request.isError
    ) {
      return
    }
    try {
      const { data } = await Vue.axios.get('recipe', {
        'axios-retry': {
          beforeTry: () => {
            commit(SET_RECIPE_ALL_REQUEST, {
              isLoading: true,
              isError: false
            })
          },
          afterTry: ({ delay, lastRequestTime }) => {
            commit(SET_RECIPE_ALL_REQUEST, {
              isLoading: false,
              isError: true,
              delay,
              lastRequestTime
            })
          }
        }
      })
      commit(SET_RECIPE_ALL_REQUEST, {
        isLoading: false,
        isSuccess: true
      })
      commit(SET_RECIPE_ALL_VALUE, data)
    } catch (e) {
      commit(SET_RECIPE_ALL_REQUEST, {
        isFatalError: true,
        isLoading: false
      })
    }
  },

  async [FETCH_RECIPE]({ commit }, id) {
    const { data } = await Vue.axios.get(`recipe/${id}`)
    return data
  },

  async SOCKET_CREATE_RECIPE({ commit }, value) {
    commit(CREATE_RECIPE, value)
  },

  async SOCKET_UPDATE_RECIPE({ commit }, value) {
    commit(UPDATE_RECIPE, value)
  },

  async SOCKET_REMOVE_RECIPE({ commit }, value) {
    commit(REMOVE_RECIPE, value)
  }
}

const mutations = {
  [SET_RECIPE_ALL_REQUEST](state, request) {
    state.all.request = {
      ...state.all.request,
      ...request
    }
  },
  [SET_RECIPE_ALL_VALUE](state, recipes) {
    state.all.value = recipes
  },
  [CREATE_RECIPE](state, recipe) {
    state.all.value.push(recipe)
  },
  [UPDATE_RECIPE](state, updatedRecipe) {
    const index = state.all.value.findIndex((v) => v.id === updatedRecipe.id)
    if (index !== -1) {
      Vue.set(state.all.value, index, updatedRecipe)
    }
  },
  [REMOVE_RECIPE](state, removedRecipe) {
    state.all.value = state.all.value.filter((v) => v.id !== removedRecipe.id)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
